import { render, staticRenderFns } from "./ModuleView.vue?vue&type=template&id=7e0bcf6b&"
import script from "./ModuleView.vue?vue&type=script&lang=js&"
export * from "./ModuleView.vue?vue&type=script&lang=js&"
import style0 from "./ModuleView.vue?vue&type=style&index=0&id=7e0bcf6b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports